import {Box, Flex, showMessage, Text, Title} from 'exsportia-components'
import {useFormikContext} from 'formik'
import {FC, useState} from 'react'
import {useQuery} from 'react-query'

import {getLocationQuery} from '../../../api/user/get-user-location'
import {checkPhoneConflictApi} from '../../../api/user/phone-api'
import {SignUpFormType} from '../../../services/auth/forms/sign-up-form'
import {useAppLoading} from '../../../services/global/hooks'
import {Button} from '../../../ui/components/button/button'
import {PhoneInput} from '../../../ui/components/phone-input/phone-input'
import {handleBackendError} from '../../../utils/error-handler'
import {useLocale} from '../../../utils/i18n'

type PhoneSignUpStepProps = {
  handleGoToNextStep: () => void
  backAction?: (e: Event) => void
}

export const PhoneSignUpStep: FC<PhoneSignUpStepProps> = ({handleGoToNextStep, backAction}) => {
  const {l} = useLocale()
  const {isLoading: isGlobalLoading} = useAppLoading()
  const [isCheckingConflict, setIsCheckingConflict] = useState(false)
  const {validateForm, values} = useFormikContext<SignUpFormType>()
  const {data: location} = useQuery(getLocationQuery({}))

  const isLoading = isGlobalLoading || isCheckingConflict

  const handleNext = () => {
    (async () => {
      const validateResult = await validateForm()
      if (!validateResult.phone) {
        setIsCheckingConflict(true)
        try {
          const response = await checkPhoneConflictApi({phone: values.phone})
          if (response.available) {
            handleGoToNextStep()
          } else {
            showMessage(l('phone_not_available'), 'error')
          }
        } catch (error) {
          handleBackendError(error, l)
        } finally {
          setIsCheckingConflict(false)
        }
      }
    })()
  }

  return (
    <Box pb={'24px'}>
      <Flex mb='8px'>
        <Title
          text={l('addPhoneNumber')}
          styleType='h2'
        />
      </Flex>
      <Flex mb='16px'>
        <Text text={l('add_phone_number_description', {caseAction: 'capitalize'})} />
      </Flex>
      <PhoneInput
        label={l('phoneNumber')}
        id='phone'
        countryCode={location?.country_code.toLowerCase()}
      />
      <Flex
        gap='16px'
        mt={'16px'}
      >
        {backAction && (
          <Button
            disabled={isLoading}
            type='secondary'
            onClick={backAction}
          >
            {l('back')}
          </Button>
        )}
        <Button
          onClick={() => {
            void handleNext()
          }}
          disabled={isLoading}
        >
          {l('next')}
        </Button>
      </Flex>
    </Box>
  )
}
